import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Icon,
  IconButton,
  Button
} from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import { BackdropCircular } from 'components';
import {
  getSMBannersAPI,
  deleteSMBannerAPI,
} from 'api';
import EditBannerSlide from './BannerSlideModal';


const options = {
  filterArrayFullMatch: false,
  responsive: 'standard',
  selectableRows: 'none',
  search: false,
  filter: false,
  download: false,
  print: false,
  pagination: true,
  viewColumns: false,
  elevation: 0,
  rowsPerPage: 20,
  rowsPerPageOptions: [20, 40, 80, 100]
};

const SMBannerSlides = () => {
  const dispatch = useDispatch();
  const [editableSlideData, setEditableSlideData] = useState(null);

  const {profile} = useSelector((state: IReduxState) => state.user);
  const {smBanners, isSMBannersLoading} = useSelector((state: IReduxState) => state.home);
  const permissions = profile?.config?.permissions || {};

  useEffect(() => {
    getSMBannersAPI({dispatch});
  }, []);

  const handleDeleteSlide = (id) => {
    deleteSMBannerAPI({dispatch, id});
  };


  const columns = [
    {
      name: 'image',
      label: 'Slide',
      options: {
        customBodyRenderLite: (dataIndex) => {
          const {image} = smBanners[dataIndex];

          return (
            <img src={image} className="max-w-full" />
          );
        }
      }
    },
    {
      name: 'enabled',
      label: 'Is Enabled',
      options: {
        setCellHeaderProps: () => ({className: 'w-200'}),
        customBodyRenderLite: (dataIndex) => {
          const {enabled} = smBanners[dataIndex];
          return (
            <div>
              {enabled ? 'Yes' : 'No'}
            </div>
          );
        }
      }
    },
    {
      name: 'openInNewTab',
      label: 'Open in new tab',
      options: {
        setCellHeaderProps: () => ({className: 'w-200'}),
        customBodyRenderLite: (dataIndex) => {
          const {openInNewTab} = smBanners[dataIndex];
          return (
            <div>
              {openInNewTab ? 'Yes' : 'No'}
            </div>
          );
        }
      }
    },
    {
      name: 'onClickUrl',
      label: 'Url'
    },
    {
      name: '',
      label: 'Action',
      options: {
        setCellHeaderProps: () => ({className: 'w-200'}),
        customBodyRenderLite: (dataIndex) => {
          const {_id} = smBanners[dataIndex];
          return (
            <>
              <IconButton
                onClick={() => handleDeleteSlide(_id)}
              >
                <Icon>delete</Icon>
              </IconButton>
              <IconButton
                onClick={() => {
                  setEditableSlideData(smBanners[dataIndex]);
                }}
              >
                <Icon>edit</Icon>
              </IconButton>
            </>
          );
        }
      }
    }
  ];

  return (
    <div>
      {permissions?.adminBannerSlidesAdd &&
      <Button
        color="primary"
        variant="contained"
        onClick={() => setEditableSlideData({ enabled: false, openInNewTab: false, image: '', onClickUrl: '' })}
        className="mb-8"
      >
        <Icon className="mr-2">add</Icon>
        <span>Add New Slide</span>
      </Button>}
      <div>
        {!!smBanners.length &&
          <MUIDataTable
            data={smBanners}
            columns={columns}
            options={options}
          />
        }
        {editableSlideData &&
          <EditBannerSlide
            setOpen={setEditableSlideData}
            slideData={editableSlideData}
          />
        }
        <BackdropCircular loading={isSMBannersLoading} />
      </div>
    </div>
  );
};

export default SMBannerSlides;
